import React from 'react';
import './uploadingFileList.module.scss';
import { FailedUploadRequest, UploadRequest } from './UserFileUploadInput';
import { UploadingFileSummary } from './UploadingFile';
import { FailedUploadFileSummary } from './FailedUploadFileSummary';
import { TransitionGroup } from 'react-transition-group';
import { Fade } from '../../../../commonv3/components/atoms/animation/Fade';

type Props = {
    requests: UploadRequest[];
};

export const UploadingFileList = ({ requests }: Props) => {
    return (
        <TransitionGroup styleName="uploading-file-list">
            {requests.map((r) => {
                return (
                    <Fade key={r.id}>
                        <UploadingFileSummary key={r.id} request={r} />
                    </Fade>
                );
            })}
        </TransitionGroup>
    );
};

type FailedProps = {
    requests: FailedUploadRequest[];
};

export const FailedFileList = ({ requests }: FailedProps) => {
    return (
        <TransitionGroup styleName="uploading-file-list">
            {requests.map((r) => {
                return (
                    <Fade key={r.id}>
                        <FailedUploadFileSummary request={r} />
                    </Fade>
                );
            })}
        </TransitionGroup>
    );
};
